import { makeStyles } from '@mui/styles';

// colors
import { colors } from '../../../../colors';

export const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    // justifyContent: 'space-between',
    position: 'relative',
  },
  rowsPerPage: {
    display: 'flex',
    alignItems: 'center',
  },
  showText: {
    fontFamily: 'Manrope',
    fontWeight: 600,
    fontSize: 14,
    color: colors.textMediumContrast,
  },
  rowsSelect: {
    '& > .MuiSelect-select': {
      paddingLeft: '0px !important',
      marginLeft: 8,
      marginRight: 5,
    },
  },
  resultsShown: {
    fontFamily: 'Manrope',
    fontWeight: 600,
    fontSize: 12,
    color: colors.textLowContrast,
  },
  nextButton: {
    marginLeft: 'auto',
    height: 40,
    fontSize: 14,
    lineHeight: '20px',
  },
  prevButton: {
    marginRight: 'auto',
    height: 40,
    fontSize: 14,
    lineHeight: '20px',
  },
});
